import React from "react";
import { FormHelperText, Select } from "@material-ui/core";

export default function CustomSelectInput({
  children,
  form,
  field,
  onChange,
  error,
  readOnly,
  variant,
  displayEmpty,
  fullWidth,
  shrink,
}) {
  const { name, value } = field;
  const { setFieldValue } = form;

  return (
    <Select
      name={name}
      value={value}
      onChange={(e) => {
        setFieldValue(name, e.target.value);
        onChange(e);
      }}
      error={error}
      fullWidth
      displayEmpty={displayEmpty}
      inputProps={{ readOnly: readOnly, shrink: shrink }}
    >
      {children}
    </Select>
  );
}
